import "./Operations.module.css";
import Header from "@/reusable_sections/Header";
import Services from "./sections/Services";
import Impact from "./sections/Impact";
import Mission from "./sections/Mission";
import Footer from "@/reusable_sections/Footer";
export default function OperationsPage() {
  return <div>
      <Header />
      <Services />
      <Impact />
      <Mission />
      <Footer />
    </div>;
}